import React from 'react';
import { MegarubigramStore } from '../_puzzles/Megarubigram/MegarubigramStore';
import MegarubigramLogo from 'url:./assets/MegarubigramLogo.svg';
import OutcomeBanner from './OutcomeBanner';

const MegarubigramPreview = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="previewTile puzzleTile" onClick={onClick}>
      <div className="megarubigramPreview">
        <div className="puzzleTitle">Megarubigram</div>
        <div className="previewImageContainer">
          <img className="rubigramIcon" src={MegarubigramLogo}/>
          <OutcomeBanner store={MegarubigramStore as any} />
        </div>
      </div>
    </div>
  );
};

export default MegarubigramPreview;